// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/textarea/index.tsx with go/sail-next-tailor-docs-publisher 

import * as React from 'react';
import { Controlled } from './Controlled.story';
import { DisabledReadOnly } from './DisabledReadOnly.story';
import { Invalid } from './Invalid.story';
import { Primary } from './Primary.story';
import { Resizeable } from './Resizeable.story';
import { Rows } from './Rows.story';
import { Size } from './Size.story';
import { Uncontrolled } from './Uncontrolled.story';
import { Width } from './Width.story';
const basic = {
  rendered: <Primary />,
  source: `<TextArea
  label="Biography"
  placeholder="Acme Inc was founded in…"
  defaultValue={EXAMPLE_TEXT}
  onChange={(e) => {
    console.log(e.target.value);
  }}
/>`
};
const resizeable = {
  rendered: <Resizeable />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextArea label="Resizable bio" defaultValue={EXAMPLE_TEXT} />
  <TextArea
    label="Unresizable bio"
    resizeable={false}
    defaultValue={EXAMPLE_TEXT}
  />
</Box>`
};
const rows = {
  rendered: <Rows />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextArea label="Biography (3 rows, default)" defaultValue={EXAMPLE_TEXT} />
  <TextArea label="Biography (6 rows)" rows={6} defaultValue={EXAMPLE_TEXT} />
</Box>`
};
const size = {
  rendered: <Size />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextArea
    label="Biography (large)"
    size="large"
    defaultValue={EXAMPLE_TEXT}
  />
  <TextArea
    label="Biography (medium, default)"
    size="medium"
    defaultValue={EXAMPLE_TEXT}
  />
  <TextArea
    label="Biography (small)"
    size="small"
    defaultValue={EXAMPLE_TEXT}
  />
</Box>
);`
};
const uncontrolled = {
  rendered: <Uncontrolled />,
  source: `<TextArea
  onChange={(e) => {
    console.log(e);
  }}
  label="About your business"
  placeholder="Our business is…"
/>`
};
const width = {
  rendered: <Width />,
  source: `<TextArea
  label="App feedback"
  defaultValue={EXAMPLE_TEXT}
/>`
};
const invalid = {
  rendered: <Invalid />,
  source: `<TextArea label="Favorite word" defaultValue={EXAMPLE_TEXT} invalid />`
};
const disabledReadOnly = {
  rendered: <DisabledReadOnly />,
  source: `<Box
  css={{
    layout: 'column',
    gap: 'medium',
  }}
>
  <TextArea label="Disabled" defaultValue={EXAMPLE_TEXT} disabled />
  <TextArea label="Readonly" defaultValue={EXAMPLE_TEXT} readOnly />
</Box>`
};
const controlled = {
  rendered: <Controlled />,
  source: `const [textValue, setTextValue] = React.useState<string>();
return (
  <TextArea
    value={textValue}
    onChange={(e) => {
      setTextValue(e.target.value);
      console.log(e);
    }}
    label="About your business"
    placeholder="Our business is…"
  />
);`
};
export const TextareaExamples = {
  basic,
  controlled,
  uncontrolled,
  disabledReadOnly,
  invalid,
  width,
  size,
  rows,
  resizeable
};
